import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { FormFocusDirective } from '@hub4b/directives/form-focus.directive';
import { TableHeaderBaseDirective } from 'src/app/core/directives/table-header-base.directive';
import { TableFilterHandler } from 'src/app/core/table-filter-handler';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { ActionType } from 'src/app/models/enums/action-type';
import { DetailTableDataType } from 'src/app/models/enums/detail-data-type';
import { DocumentFlux } from 'src/app/models/enums/document-flux';
import { DocumentType } from 'src/app/models/enums/document-type';
import { PropertyType } from 'src/app/models/enums/property-type';
import { ColumnDefinition } from 'src/app/models/server/column-definition';

@Component({
    selector: 'app-detail-table-header-cell',
    templateUrl: './detail-table-header-cell.component.html',
    styleUrls: ['./detail-table-header-cell.component.scss'],
    imports: [FormsModule, FormFocusDirective, ReactiveFormsModule, MatSortModule]
})
export class DetailTableHeaderCellComponent extends TableHeaderBaseDirective {
    /**
     * Références des icônes utilisés dans le template.
     */
    public resetFilterIcon = faEraser;

    /**
     * Références des Enums utilisées dans le template.
     */
    public PropertyType = PropertyType;
    public DetailTableDataType = DetailTableDataType;
    public DocumentType = DocumentType;
    public DocumentFlux = DocumentFlux;
    public ActionType = ActionType;

    /**
     * Gestionnaire des filtres.
     */
    @Input()
    public filterHandler: TableFilterHandler;

    /**
     * Définition de la colonne correspondant à cette cellule d'en-tête.
     */
    @Input()
    public column: ColumnDefinition;

    /**
     * Type de donnée affichée.
     */
    @Input()
    public detailTableDataType: DetailTableDataType;

    /**
     * Constructeur
     * @param datePipe
     * @param displayLabelHelper
     */
    constructor(public enumHelper: EnumHelper) {
        super();
    }
}
